module.exports = __webpack_public_path__ + "img/2_user.280fbb00.svg";